import { render } from "./balao.vue?vue&type=template&id=fd314b30&scoped=true"
import script from "./balao.vue?vue&type=script&lang=js"
export * from "./balao.vue?vue&type=script&lang=js"

import "./balao.vue?vue&type=style&index=0&id=fd314b30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd314b30"]])

export default __exports__